import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { loginUser } from "../APIServices/Login/loginThunk";
import { resetAlert } from '../APIServices/alertSlice';
import './LoginPage.css';
import Bowser from "bowser";
import SpinnerLoader from "../sharedFiles/loader/spinnerLoader";
import { GetAdversitment, GetCustomerMaster, GetCustomerQRCode, Getoffers } from "../APIServices/CustomerMasterService/CustomerMasterThunk";
// import { decryptUserInfo } from '../sharedFiles/decryption/Decryption';

function LoginPage() {
    // State to handle form input values and errors
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [usernameError, setUsernameError] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [authError, setAuthError] = useState("");  // Keep authError state for error messages (if needed)
    const [sessionExpired, setSessionExpired] = useState(false);
    const [isTabActive, setIsTabActive] = useState(true);
    const userAgent = window.navigator.userAgent;
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { loading, isAuthenticated, error } = useSelector((state) => state.login);
    const hasNavigated = useRef(false);

    // Effect for session expiration check
    useEffect(() => {
        const expired = localStorage.getItem("sessionExpired") === "true";
        setSessionExpired(expired);
        if (expired) {
            localStorage.removeItem("sessionExpired");
        }
    }, []);

    // Handle tab visibility change
    useEffect(() => {
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") {
                setIsTabActive(true);
                if (sessionExpired && error) {
                    Swal.fire({
                        position: "center",
                        icon: "error",
                        title: "Your session has expired. Please log in again.",
                        showConfirmButton: false,
                        timer: 5000,
                    }).then(() => {
                        localStorage.removeItem("sessionExpired");
                    });
                    dispatch(resetAlert());
                }
            } else {
                setIsTabActive(false);
            }
        };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            document.removeEventListener("visibilitychange", handleVisibilityChange);
        };
    }, [error, dispatch, sessionExpired]);

    // Handle input changes and validate for character limit
    const handleInputChange = (e, setValue, setError, characterLimit) => {
        const inputValue = e.target.value;
        if (inputValue.length <= characterLimit) {
            setValue(inputValue);
            setError(""); // Clear any previous error
        } else {
            setError(`Character limit exceeded. Maximum allowed: ${characterLimit}`);
        }
    };

    // Handle form submission and dispatch the login action
    const handleSubmit = (e) => {
        e.preventDefault();
        let hasError = false;

        if (!username.trim()) {
            setUsernameError("Username is required.");
            hasError = true;
        } else {
            setUsernameError("");
        }

        if (!password.trim()) {
            setPasswordError("Password is required.");
            hasError = true;
        } else {
            setPasswordError("");
        }

        if (hasError) return;

        const browser = Bowser.getParser(userAgent);
        const body = {
            username: username,
            password: password,
            DeviceInfo: JSON.stringify(browser.parsedResult)
        }
        dispatch(loginUser(body));
    };

    // Effect to navigate when the user is authenticated
    useEffect(() => {
        if (isAuthenticated && !hasNavigated.current) {
            console.log("isAuthenticated :", isAuthenticated);
            console.log("hasNavigated :", hasNavigated);            
            hasNavigated.current = true;
            dispatch(GetAdversitment());
            // dispatch(Getoffers());
            // dispatch(GetCustomerQRCode());
            navigate("/DashBoard",{ state: { showAd: true } });
        }
    }, [isAuthenticated, navigate]);

    // Effect to show error alert when authentication fails
    useEffect(() => {
        if (error) {
            Swal.fire({
                position: "center",
                icon: "error",
                title: error,
                showConfirmButton: false,
                timer: 5000,
            });
        }
    }, [error]);

    return (
        <>
            <div className='loginImage'></div>
            <div className='loginGradient'></div>
            <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "transparent" }}>

                <div className="form-container bg-white p-4 rounded shadow-sm" style={{ maxWidth: "400px", width: "100%" }}>

                    <form onSubmit={handleSubmit}>
                        {/* <div className='LoginHeader'>DEALER PORTAL

                        </div> */}
                        <img class="mb-4 mx-auto d-block" src="logo.jpeg" alt="Melwa Logo" width="120" height="90" />
                        {/* <h1 className="h3 mb-3 fw-normal text-center">Login</h1> */}

                        {/* Username input with validation */}
                        <div className="form-floating mb-3">
                            <input
                                type="text"
                                className={`form-control ${usernameError ? "is-invalid shake" : ""}`}
                                id="floatingUsername"
                                placeholder="Username"
                                autoComplete="off"
                                value={username}
                                onChange={(e) => handleInputChange(e, setUsername, setUsernameError, 20)}
                                required
                                style={{ outline: "none", boxShadow: "none" }}
                            />
                            <label htmlFor="floatingUsername">Username</label>
                            {usernameError && <div className="invalid-feedback">{usernameError}</div>}
                        </div>

                        {/* Password input with validation */}
                        <div className="form-floating mb-3">
                            <input
                                type="password"
                                className={`form-control ${passwordError ? "is-invalid shake" : ""}`}
                                id="floatingPassword"
                                placeholder="Password"
                                value={password}
                                onChange={(e) => handleInputChange(e, setPassword, setPasswordError, 30)}
                                required
                                style={{ outline: "none", boxShadow: "none" }}
                            />
                            <label htmlFor="floatingPassword">Password</label>
                            {passwordError && <div className="invalid-feedback">{passwordError}</div>}
                        </div>

                        {/* Submit button */}
                        <button className="btn w-100 py-2" type="submit" style={{ backgroundColor: "#1d3240", border: "none", color: "white" }}>
                            Login
                        </button>
                        {loading &&<div className="loaderbg">
                         <SpinnerLoader/>
                        </div>}
                        {/* Authentication error message */}
                        {authError && <div className="alert alert-danger mt-3">{authError}</div>}
                    </form>
                </div>
            </div>
        </>
    );
}

export default LoginPage;


















// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { useLocation, useNavigate } from 'react-router-dom';
// import './LoginPage.css';
// import { Box, TextField } from '@mui/material';
// import { useDispatch, useSelector } from 'react-redux';
// import { selectUser, setUser } from '../ReduxStore/userReducer';
// import { SapConnection, userLogs } from '../API/API';
// import { decryptUserInfo } from '../sharedFiles/decryption/Decryption';
// import Swal from 'sweetalert2';
// import { resetAlert } from '../ReduxStore/alertSlice';
// import Footer from '../sharedFiles/footer/footer';
// import Bowser from 'bowser';
// import { loginUser } from '../APIServices/Login/loginThunk';

// function LoginPage() {
//     // Initialize state variables
//     const [username, setUsername] = useState('');
//     const [password, setPassword] = useState('');
//     const dispatch = useDispatch();
//     const userData = useSelector(selectUser);
//     const UserId = userData?.UserId;
//     const Username = userData?.UserName;
//     const databaseName = userData?.DBName;
//     const companyName = userData?.CompanyName;
//     const jwtToken = userData?.JwtToken;
//     const [isUsernameVibrating, setIsUsernameVibrating] = useState(false);
//     const [isPasswordVibrating, setIsPasswordVibrating] = useState(false);
//     const usernameInputClassName = isUsernameVibrating ? 'vibrate' : '';
//     const passwordInputClassName = isPasswordVibrating ? 'vibrate' : '';
//     const [multiDatabase, setMultiDatabase] = useState(false);
//     const [databaseNames, setDatabaseNames] = useState(null);
//     const [database, setdatabase] = useState('');
//     const [usernameError, setUsernameError] = useState('');
//     const [passwordError, setPasswordError] = useState('');
//     const [dataListShow, setDataListShow] = useState(false);
//     const [decryptUserValues, setDecryptValues] = useState([]);
//     const [authError, setAuthError] = useState('');
//     const usernameCharacterLimit = 20;
//     const passwordCharacterLimit = 30;
//     const [showSuccessMessage, setShowSuccessMessage] = useState(false);
//     const hasUsernameError = !!usernameError;
//     const hasPasswordError = !!passwordError;
//     const navigate = useNavigate();
//     const location = useLocation();
//     const alertShown = useSelector((state) => state.alert.alertShown);
//      const { loading, isAuthenticated, error } = useSelector((state) => state.login);

//     const [isTabActive, setIsTabActive] = useState(true); // Track tab visibility
//     const [sessionExpired, setSessionExpired] = useState(false);

//     useEffect(() => {
//         // Check if session expired flag is set in local storage
//         const expired = localStorage.getItem('sessionExpired') === 'true';
//         setSessionExpired(expired);
//         if (expired) {
//             localStorage.removeItem('sessionExpired');
//         }
//     }, []);
//     useEffect(() => {
//         const handleVisibilityChange = () => {
//             if (document.visibilityState === 'visible') {
//                 setIsTabActive(true);
//                 // Show alert when tab is visible and session is expired
//                 if (sessionExpired && alertShown) {
//                     Swal.fire({
//                         position: "center",
//                         icon: "error",
//                         title: 'Your session has expired. Please log in again to continue.',
//                         showConfirmButton: false,
//                         timer: 5000
//                     }).then(() => {

//                         localStorage.removeItem('sessionExpired'); // Clear session expired flag after showing the alert
//                     });
//                     dispatch(resetAlert());
//                 }
//             } else {
//                 setIsTabActive(false);
//             }
//         };

//         document.addEventListener('visibilitychange', handleVisibilityChange);

//         return () => {
//             document.removeEventListener('visibilitychange', handleVisibilityChange);
//         };
//     }, [alertShown, dispatch, sessionExpired]);

//     useEffect(() => {
//         // Immediately show the alert if the session expired and user is on the page
//         if (sessionExpired && isTabActive && alertShown && document.visibilityState !== 'hidden') {
//             Swal.fire({
//                 position: "center",
//                 icon: "error",
//                 title: 'Your session has expired. Please log in again to continue.',
//                 showConfirmButton: false,
//                 timer: 5000
//             }).then(() => {

//                 localStorage.removeItem('sessionExpired'); // Clear session expired flag after showing the alert
//             });
//             dispatch(resetAlert());
//         }
//     }, [sessionExpired, isTabActive, alertShown, dispatch]);

//     const handleInputChange = (e, characterLimit, setValue, setIsVibrating, setError) => {
//         const inputValue = e.target.value;

//         if (inputValue.length <= characterLimit - 1) {
//             setValue(inputValue);
//             setIsVibrating(false);
//             setError(''); // Clear error message when within limit
//         } else {
//             setIsVibrating(true); // If validition is failed it will vibrate
//             setError(`Character limit exceeded. Maximum allowed: ${characterLimit}`);
//         }
//     };

//     // This is set for vibrate a input field even pressing a key
//     const handleKeyDown = (setIsVibrating, setError) => {
//         setIsVibrating(false);
//         setError('');
//     };

//     // This also a validition functionality for checking a characterLimit
//     const handleBlur = (value, characterLimit, setError) => {
//         if (value.trim() === '') {
//             // setError('This field is required.');
//         } else if (value.length > characterLimit - 1) {
//             setError(`Character limit exceeded. Maximum allowed: ${characterLimit}`);
//         } else {
//             setError('');
//         }
//     };

//     // Handle form submission
//     const handleSubmit = async (e) => {
//         e.preventDefault(); // Prevent default form submission
//         let hasError = false;
//         // Form validation
//         if (!username.trim()) {
//             setUsernameError('Username is required.');
//             setIsUsernameVibrating(true);
//             hasError = true;
//             setTimeout(() => {
//                 setIsUsernameVibrating(false);
//             }, 300);
//         } else {
//             setUsernameError('');
//         }

//         if (!password.trim()) {
//             setPasswordError('Password is required.');
//             setIsPasswordVibrating(true);
//             hasError = true;
//             setTimeout(() => {
//                 setIsPasswordVibrating(false);
//             }, 300);
//         } else {
//             setPasswordError('');
//         }
//         if (hasError) {
//             return;
//         }
//         // If any field is missing, stop further processing
//         if (!username.trim() || !password.trim()) {
//             return;
//         }
//         setLoading(true);
//         const userAgent = window.navigator.userAgent;
//         const browser = Bowser.getParser(userAgent);
//         const deviceInfo = browser.parsedResult
//         const body = {
//             userName: username,
//             password: password,
//             deviceInfo:deviceInfo,
//         };

//         try {
//             // Send a POST request to the login endpoint
//             // const response = await axios.post(loginUser, body);
//             dispatch(loginUser(body));

//             //  const data = "+UX8KKfJvmXj3D/Km9fDO6sfDPMdrrBkAg8MbJELmL3n3tx1LIUSIqt70DhH7zJ+K837i/jbfYubH8LopYsYs0EfcL8snjwH190xngsd8AHy8RgS+n1sbvy66OF3MsMXxyPy3HikUnZTOHvUI24KaSuKXCokvpDQqg0CnqdhqJpXMWUxYZR/P+RYYahRbrVXIgn8b80yBxD35J+BEfGVaMxFIYf9ynJIku/VlDXuI0x6r2EuWritw9XVvDkcg39MGyVtIM7r3rR8l11KPPYGyEdG+JCfS6D1tW+pJ6RKQalPhc1rThBq8Te2Su3Tls2bnpOEODTuRRV/EVpPRktW4b0ml5g7p/3lZRmfuINpTIvgKhHyT4YVkMC/U+P3JIuDvEbZvdBY0fcT2EIdgHqAzR1oE4J+UZ3Fm+YMohYZO3A="
//             // const decryptValues = decryptUserInfo(response.data);
//             // setDecryptValues(decryptValues);
//             // if (Array.isArray(decryptValues) && decryptValues.length > 0) {
//             //     if (decryptValues.length > 1) {
//             //         const database = decryptValues.map(user => user.CompanyName);
//             //         setDatabaseNames(database);
//             //         setMultiDatabase(true);
//             //     } else {
//             //         const userObject = decryptValues[0];
//             //         dispatch(setUser(userObject));
//             //         navigate('/DashBoard');
//             //         localStorage.setItem('loginTime', Date.now());
//             //         const databaseName = userObject.DBName;
//             //         const company = await axios.post(`${SapConnection}${databaseName}`)
//             //         setShowSuccessMessage(true);
//             //         setTimeout(() => {
//             //             setShowSuccessMessage(false);
//             //         }, 3000);
//             //         const successMessage = 'Login successful! Welcome ' + username;
//             //         localStorage.setItem('successMessage', successMessage);
//             //         await postDeviceInfo();
//             //     }

//             // }
//             // else {
//             //     setAuthError("Invalid UserName or Password.");
//             // }
//         } catch (error) {
//             // Error handling
//             if (error.response && error.response.status === 404) {
//                 setAuthError("Invaild Credentials.");
//             } else {
//                 console.error("Authentication error:", error.message, error.response);
//                 setAuthError("Invaild Credentials.");
//             }
//         } finally {
//             setLoading(false); // Set loading back to false
//         }
//     };


//     const handleDatabaseClick = (database) => {
//         setdatabase(database)
//         setDataListShow(false);
//     }
//     const handleProceed = () => {
//         const result = decryptUserValues.find(item => item.CompanyName === database);
//         dispatch(setUser(result));
//         navigate('/DashBoard');
//     }
//     return (
//         <>
//             <div className={`loginPage pt-3  d-flex justify-content-center align-items-center col-12 col-sm-12 ${hasUsernameError || hasPasswordError ? 'error-container' : ''}`}>
//                 <div className='loginImage'></div>
//                 <div className='loginGradient'></div>
//                 {multiDatabase && databaseNames ?
//                     (<div className='loginform d-flex flex-column gap-3 justify-content-center col-lg-5 col-xl-4 col-xxl-3  col-md-8 col-sm-8 col-10 mx-auto text-center pt-4 pb-4'>
//                         <TextField
//                             // {...params}
//                             label="Choose a Company"
//                             className="databaseField"
//                             id="standard-basic"
//                             variant="standard"

//                             onClick={() => setDataListShow(true)}
//                             value={database}
//                         />
//                         {databaseNames && dataListShow && (

//                             <ul
//                                 className="databaseListContainer"
//                             // ref={wrapperRef}
//                             >
//                                 {databaseNames.map((database, index) => (
//                                     <li key={index} className="databaseListItem"
//                                         onClick={() => handleDatabaseClick(database)}
//                                     >
//                                         {database}
//                                     </li>
//                                 ))}
//                             </ul>
//                         )}
//                         <button onClick={handleProceed}>
//                             proceed
//                         </button>
//                     </div>) :
//                     (<div className={`loginform col-lg-5 col-xl-4 col-xxl-3  col-md-8 col-sm-8 col-10 mx-auto text-center pt-4 pb-4 ${hasUsernameError || hasPasswordError ? 'error-form' : ''}`}>
//                         <div className='logo-container'>
//                             {/* <div className=' logo1'></div>
//                     <div className='logo2'></div> */}
//                             <div className='LoginHeader'>DEALER PORTAL

//                             </div>
//                         </div>
//                         <Box component="form" onSubmit={handleSubmit} noValidate
//                             className={`d-flex flex-column align-items-center col-lg-12 ${hasUsernameError || hasPasswordError ? 'error-form' : ''}`}>
//                             <div className='userwitherror'>
//                                 <TextField
//                                     margin="normal"
//                                     required
//                                     id="Username"
//                                     value={username}
//                                     onChange={(e) => handleInputChange(e, usernameCharacterLimit, setUsername, setIsUsernameVibrating, setUsernameError)}
//                                     onBlur={() => handleBlur(username, usernameCharacterLimit, setUsernameError)}
//                                     maxRows={usernameCharacterLimit}
//                                     onKeyDown={() => handleKeyDown(setIsUsernameVibrating, setUsernameError)}
//                                     label="Username"
//                                     name="Username"
//                                     autoComplete="off"
//                                     autoFocus
//                                     className={`login-input ${usernameInputClassName}`}
//                                 />
//                                 {hasUsernameError && <p className="error-message bg-transparent ">{usernameError}</p>}
//                             </div>
//                             <TextField
//                                 margin="normal"
//                                 required
//                                 name="password"
//                                 label="Password"
//                                 id="password"
//                                 value={password}
//                                 onChange={(e) => handleInputChange(e, passwordCharacterLimit, setPassword, setIsPasswordVibrating, setPasswordError)}
//                                 onBlur={() => handleBlur(password, passwordCharacterLimit, setPasswordError)}
//                                 type="password"
//                                 placeholder="Password"
//                                 maxLength={passwordCharacterLimit}
//                                 onKeyDown={() => handleKeyDown(setIsPasswordVibrating, setPasswordError)}
//                                 autoComplete="off"
//                                 className={`login-input ${passwordInputClassName}`}
//                             />
//                             <div className='loginBtnDiv'>
//                                 <button className=' col-lg-5 col-md-3 col-sm-3 col-4' type="submit" disabled={loading}>
//                                     {loading ? 'Logging in...' : 'Login'}
//                                 </button>
//                                 {authError && <p className="error-message">{authError}</p>}
//                             </div>
//                         </Box>
//                     </div>
//                     )}
//             </div>
//             <Footer />
//         </>
//     );
// }

// export default LoginPage;
